class UsersConfig {

    static initRoute ($stateProvider, $urlRouterProvider) {
        'ngInject';
        $stateProvider.state('public.users', {
          url: "/users",
          abstract: true,
          views: {
            'content@': {
              template: require("./users.html"),
              controller: "UsersController as users"
            }
          }
        }).state('protected.users', {
          url: "/users",
          abstract: true,
          views: {
            'content@': {
              template: require("./users.html"),
              controller: "UsersController as users"
            }
          }
        }).state('public.users.start', {
          url: "/start",
          template: require("./start.html"),
          controller: "StartUsersController as usersstart"
        }).state('public.users.policy', {
          url: "/policy",
          template: require("./policy.html"),
          controller: "PolicyController as policy"
        }).state('public.users.login', {
          url: "/login",
          template: require("./login.html"),
          controller: "LoginUsersController as userslogin"
        }).state('public.users.additional-data', {
          url: "/additional-data",
          template: require("./additional-data.html"),
          controller: "AdditionalDataUsersController as additionaldata"
        }).state('public.users.too-many-failed-logins', {
          url: "/too-many-failed-logins",
          template: require("./too-many-failed-logins.html"),
          controller: "TooManyFailedLoginsUsersController as toomanyfailedlogins"
        }).state('public.users.error', {
          url: "/error",
          template: require("./error.html"),
          controller: "ErrorUsersController as error"
        }).state('protected.users.select-resource', {
          url: "/select-resource",
          template: require("./select-resource.html"),
          controller: "SelectResourceUsersController as selectresource"
        }).state('protected.users.changePassword', {
          url: "/change-password",
          template: require("./change-password.html"),
          controller: "ChangePasswordUsersController as changepassword"
        });
        $urlRouterProvider.otherwise("/public/users/start");
    }
}

export default UsersConfig.initRoute;



// WEBPACK FOOTER //
// ./src/users/users.config.js